/** @typedef {import("../../../api/types").Attention} Attention */
import React from "react";
import {Link} from "react-router-dom";
import {formatMoney} from "../../../shared/utils/format";
import "./AttentionCard.css";

const plural = (/** @type {number} */ n, /** @type {string} */ one, /** @type {string} */ many) =>
    `${n} ${n === 1 ? one : many}`;

/**
 * What is waiting on the provider, each a link to the orders it is about:
 * sent quotes about to run out or left unanswered, confirmed orders to do,
 * orders done and not paid. Only what there is shows up.
 *
 * @param {{data: Attention|null, error?: boolean}} props `data` is null while loading
 */
const AttentionCard = ({data, error = false}) => {
    let body;
    if (error) {
        body = <p className="attention__note">Não foi possível carregar esta parte.</p>;
    } else if (!data) {
        body = <p className="attention__note">Carregando…</p>;
    } else {
        const {awaiting_payment: awaiting} = data;
        const items = [
            {
                key: "expiring",
                count: data.expiring_soon,
                to: "/orders?status=SE",
                text: `${plural(data.expiring_soon, "orçamento enviado vence", "orçamentos enviados vencem")} nos próximos ${data.expiring_days} dias`,
            },
            {
                key: "unanswered",
                count: data.unanswered,
                to: "/orders?status=SE",
                text: `${plural(data.unanswered, "orçamento enviado", "orçamentos enviados")} sem resposta há ${data.unanswered_days} dias ou mais`,
            },
            {
                key: "to-complete",
                count: data.to_complete,
                to: "/orders?status=CO",
                text: `${plural(data.to_complete, "ordem confirmada", "ordens confirmadas")} para concluir`,
            },
            {
                key: "awaiting",
                count: awaiting.orders,
                to: "/orders?status=DO",
                text: `${plural(awaiting.orders, "ordem concluída aguardando", "ordens concluídas aguardando")} pagamento (${formatMoney(awaiting.revenue, data.currency)})`,
            },
        ].filter((item) => item.count > 0);

        body = items.length ? (
            <ul className="attention__list">
                {items.map((item) => (
                    <li key={item.key}>
                        <Link to={item.to}>{item.text}</Link>
                    </li>
                ))}
            </ul>
        ) : (
            <p className="attention__note">Tudo em dia: nada esperando por você.</p>
        );
    }

    return (
        <section className="attention" aria-labelledby="attention-title">
            <h5 id="attention-title" className="mb-3">
                Precisa de atenção
            </h5>
            {body}
        </section>
    );
};

export default AttentionCard;
